import { useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import LoginPage from './LoginPage';
import SSOCallback from './SSOCallback';
import App from '../../App';

export default function AuthGate() {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Clerk redirects here after Google OAuth completes. We special-case
  // it inline (rather than as a top-level <Route> in main.jsx) so we
  // don't have to wrap App.jsx's existing absolute-path <Routes> in a
  // wildcard parent — that breaks React Router v6 child matching.
  if (location.pathname === '/sso-callback') {
    return <SSOCallback />;
  }

  if (loading) {
    return (
      <div className="min-h-screen bg-bone flex items-center justify-center">
        <div className="text-navy text-[14px]">Loading...</div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <LoginPage />;
  }

  return <App />;
}
